import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import useProcessData from "../../../CommonFunction/ProcessData";
import { LoadTable } from "../../Components";
import { AddLedger } from "../../Components/FormComponents";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import Loading from "../../Components/Loading/Loading";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import "./AccountLedger.scss";

const queryFunction = (fields) => {
  return gql`
      query getBalancesInRange($getBalancesInRangeId: ID) {
    getBalancesInRange(id: $getBalancesInRangeId) {
      AccountBalanceData {
        _id
        Unique_Id
        Account_Type_Id {
          _id
          Unique_Id
          UserId
          Transporter_Type
          Reference
          Bank_Name
          Proprietor_Name
          Business_Name
          Mobile_Number
          Name
          Alternate_Name
          Account_Group
          Address_Line_One
          Address_Line_Two
          Pincode
          Balance_Method
          Credit_Or_Debit
          Account_Groups {
            _id
            Unique_Id
            Search_Value
            Account_Group
            Group_Under
            Group_Type
            Order_No
            Primary
            Report_Side
            Is_Lock
            Created_By
            createdAt
            updatedAt
          }
        }
        Account_Type
        Account_Name
        Search_Value
        Account_Balance
        Financial_Openeing_Balance
        Financial_Openeing_Balance_Type

        Closing_Balance
        Closing_In_Cr
        Closing_In_Dr
        createdAt
        updatedAt
      }
      Months {
        _id
      ${fields?.join(" ")}
      }
    }
  }
  `;
};
//        Financial_Closing_Balance
// Financial_Closing_Balance_Type
export const MonthlyAccountLedger = () => {
  const [loadingState, setLoading] = useState(true);
  const [openViewPortal, setOpenViewPortal] = useState(false);
  const Key = "Account_Ledger";
  const colAddition = ["totalCredit", "totalDebit"];
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  const config = useMemo(
    () => ({
      dataKey: "Months",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["is_Audit", "__typename"],
      dateKeysWithoutTime: ["Date"],
    }),
    []
  );
  const [fetchMonthlyLedgerData, { loading: queryLoading, error, data }] = useLazyQuery(queryFunction(), {
    fetchPolicy: "network-only",
    variables: {
      getBalancesInRangeId: id,
    },
    onCompleted: () => setLoading(false),
  });

  const [formData, setFormData] = useState([]);
  const { TableHeaders } = useFetchTableData(queryFunction, fetchMonthlyLedgerData, setLoading, Key);

  useProcessData(data?.getBalancesInRange, setFormData, config, error);
  useEffect(() => {
    // console.log(CurrentTitle, "app");
    document.title = "Account Ledger";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);
  const handleClick = (event) => {
    if (event.ctrlKey) {
      let accData = data?.getBalancesInRange?.AccountBalanceData?.Account_Type_Id;
      console.log(accData, "accDataaccDataaccDataaccDataaccData");
      dispatch({
        type: "UNIQUE_TABLE_LIST",

        payload: {
          key: "Account_Vouchers",
          data: {
            Selected_Rows: [accData],
            Selected_Row: accData,
            SelRow_id: [accData?._id],
            SelRow_ids: [accData?._id],
          },
        },
      });
      setShow(true);
      setOpenViewPortal(true);
    }
  };
  const accountBalanceData = data?.getBalancesInRange?.AccountBalanceData;
  useEffect(() => {
    if (accountBalanceData?.Account_Type_Id?.Name) {
      window.__customPageTitleSet = true;
      document.title = accountBalanceData.Account_Type_Id.Name;
    }

    return () => {
      window.__customPageTitleSet = false;
    };
  }, [accountBalanceData?.Account_Type_Id?.Name]);

  const isLoading = queryLoading || loadingState;
  console.log(formData);

  return (
    <div>
      <HeaderDiv
        title={"Monthly Ledger Data"}
        data={formData}
        TableKey={Key}
        IsDateSearchShow={false}
        MoreActions={{
          Is_Back: true,
          Is_Forword: true,
          Is_Add: false,
          Is_View: false,
          Is_Delete: false,
          Is_Edit: false,
          Is_Print: false,
        }}
      />
      <div className="AccountDetailsDiv">
        <div>
          <p className="heading">Account</p>
          <div onClick={handleClick} className="AccountName">
            <p>
              {accountBalanceData?.Account_Type_Id?.Name ||
                accountBalanceData?.Account_Type_Id?.Business_Name ||
                accountBalanceData?.Account_Type_Id?.Proprietor_Name ||
                "-"}
            </p>
            <p className="uniqueID">{accountBalanceData?.Unique_Id ? `(${accountBalanceData?.Unique_Id})` : ""}</p>
          </div>
        </div>
        <div>
          <p className="heading">Opening Balance</p>
          <p>
            {accountBalanceData?.Financial_Openeing_Balance == null
              ? 0
              : accountBalanceData?.Financial_Openeing_Balance}{" "}
            {accountBalanceData?.Financial_Openeing_Balance_Type}
          </p>
        </div>
        <div>
          <p className="heading">Closing Balance</p>
          <p>
            {accountBalanceData?.Financial_Closing_Balance == null ? 0 : accountBalanceData?.Financial_Closing_Balance}{" "}
            {accountBalanceData?.Financial_Closing_Balance_Type}
          </p>
        </div>
        <div>
          <p className="heading">Group Name</p>
          <p className="closingBalance">{accountBalanceData?.Account_Type_Id?.Account_Groups?.Account_Group || "-"}</p>
        </div>
      </div>

      {isLoading ? (
        <Loading />
      ) : formData.length === 0 ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {queryLoading && <div className="loader-line-div" />}
          <LoadTable
            data={formData}
            loading={loadingState}
            error={error}
            title={Key}
            ledgerTable={true}
            colAddition={colAddition}
            TableHeaders={TableHeaders}
          />
        </>
      )}
      {openViewPortal ? (
        <AddLedger
          AccountID={accountBalanceData?.Account_Type_Id?._id}
          show={show}
          setShow={setShow}
          ParentPortalCloseFunction={() => {
            setOpenViewPortal(false);
            setShow(false);
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};
